import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { mensajeErrorCarga } from '../../core/http-errors';
import { ErrorFichaComponent } from '../error-ficha/error-ficha.component';
import { Component } from '@angular/core';
import { Cargo, CargosService, ResponseCargos } from '../../../api';
import { ItemType } from '../formulario/request.model';
import { CoreComponent } from '../core/core.component';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'app-cargos',
  standalone: true,
  imports: [CoreComponent, SpinnerComponent, ErrorFichaComponent],
  templateUrl: './cargos.component.html',
  styleUrl: './cargos.component.scss'
})
export class CargosComponent {

  type: ItemType = ItemType.CARGOS;
  cargos: Cargo[] = [];
  titleForm = 'Crear cargo';
  mode: 'list' | 'Crear' | 'Editar' | 'showItem' = 'list';

  error = '';
  loading: boolean = true;

  constructor(
    private router: Router,
    private cargosService: CargosService,
  ) { }

  ngOnInit() {
    this.error = '';
    this.loading = true;
    this.cargosService.cargosGet().subscribe({
      next: (res: ResponseCargos) => {
        if (res.status?.status === 200) {
          this.cargos = res.cargos!;
          this.loading = false;
        } else {
          this.error = mensajeErrorCarga(undefined, 'el listado de cargos');
          this.loading = false;
        }
      },
      error: (err: HttpErrorResponse) => {
        this.error = mensajeErrorCarga(err, 'el listado de cargos');
        this.loading = false;
      }
    });
  }

  irAInicio() {
    this.router.navigateByUrl('/home');
  }

}
